<template>
  <div class="main-menu__body">
    <div class="menu-header">
      <el-tag class="main-menu__header" :title="header.overTitle">
        <span class="el-icon-menu"></span>
        <label>{{header.title}}</label>
      </el-tag>
    </div>
    <div class="main-menu__content">
      <el-scrollbar>
        <el-menu
          class="el-nav-menu-vertical"
          @open="handleOpen"
          @close="handleClose"
          :collapse="$store.getters.config.navMenu.collapse===true"
        >
          <bs-menu-item v-for="item in data" :key="item.id" :item="item" menu-class="main-menu"></bs-menu-item>
        </el-menu>
      </el-scrollbar>
    </div>
  </div>
</template>

<style lang=<style lang="scss">
.main-menu__body {
  .el-menu-item:hover,
  .el-menu-item:focus {
    outline: none;
    background-color: rgba(250, 247, 246, 0.5);
  }
  .el-submenu__title:hover {
    background-color: rgba(250, 247, 246, 0.5);
  }
  a{
    text-decoration: none;
  }
}
</style>
 

<script>
import { getMenu } from "../../actions/auth/popedom";
import { listConvertTree } from "../../utils/tree";

export default {
  data() {
    return {
      header: {
        title: this.$store.getters.auth.menu.menuName
      },
      data: [],
      parentId: this.$store.getters.auth.menu.menuId,
      res: {}
    };
  },
  //接收上级组件传递过来的属性  {{screenWidth}}
  props: ["screenWidth"],

  components: {
    BsMenuItem: () => import("../../components/bs-menu-item")
  },
  watch: {
    //值变更后触发
    parentId: function(val, oldVal) {
      this.loadData();
    },
    $route: function(to, from) {
      let console = this.$store.getters.console;
      if (console.system === true) {
        console.system = false;
        this.$store.dispatch("console", console);
        this.loadData();
      } else {
        this.changeRoute();
      }
    }
  },
  created() {
    //注册全局方法
    this.$root.$on("handleChangeMenuParentId", item => {
      this.parentId = this.$store.getters.auth.menu.menuId;
      this.header.title = this.$store.getters.auth.menu.menuName;
      this.loadData();
    });
    //外部调用
    // this.$root.$emit("handleChangeMenuParentId",null);
  },
  mounted: function() {
    this.loadData();
  },
  methods: {
    loadData() {
      var that = this;
      getMenu({
        _sysId: this.$store.getters.auth.system.sysId,
        _objectId: this.$store.getters.auth.user.userId,
        _parentId: this.parentId
      }).then(res => {
        if (!res) {
          this.data = [];
          return;
        }
        that.res = res;
        let arry = [];
        let tempData = res.data;
        //处理路由数据
        tempData.map((item, index) => {
          //arry.push(Object.assign({},item,{id:item.menuId,name:item.menuName}));
          if (!item.hasOwnProperty("path")) {
            item.path = null;
          }
          if ((item.path || "") !== "") {
            if (item.path.includes("$menuFn") !== true) {
              item.path =
                item.path +
                (item.path.indexOf("?") === -1 ? "?" : "&") +
                "_menuId=" +
                item.menuId;
            }
          }
          //头参数替换
          if (
            item.path &&
            item.path.indexOf("{") !== -1 &&
            item.path.indexOf("}") !== -1
          ) {
            let headers = that.$store.getters.headers;
            for (let paramKey in headers) {
              item.path = item.path.replace(
                "{" + paramKey + "}",
                headers[paramKey]
              );
            }
          }
          arry.push(
            Object.assign(
              {},
              {
                id: item.menuId,
                parentId: item.parentId,
                name: item.menuId,
                path: item.path || "",
                meta: Object.assign(
                  {
                    name: item.menuName,
                    icon: item.icon || "el-icon-tickets",
                    default: item.isDefault || 0,
                    hidden: item.isHidden || 0
                  },
                  item.meta
                )
              }
            )
          );
        });
        let data = listConvertTree(arry, that.parentId);
        this.data = data.children;
        that.changeRoute();
      });
    },
    changeRoute() {
      let navData = [];
      if (this.$route.query._menuId) {
        navData = this.childrenTree(
          [{ menuId: this.$route.query._menuId }],
          this.res.data
        );
      }
      this.$store.dispatch("nav", navData);
      this.$root.$emit("handleChangeMainNav", null);
    },
    childrenTree(array, data) {
      for (let index = 0; index < data.length; index += 1) {
        if (array[0].menuId == data[index].menuId) {
          array[0] = data[index];
        }
      }
      for (let index = 0; index < data.length; index += 1) {
        if (array[0].parentId === data[index].menuId) {
          array.unshift(data[index]);
          // array.reverse();
          this.childrenTree(array, data);
          break;
        }
      }
      return array;
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {}
  }
};
</script>
